import React, { useEffect, useState } from "react";
import FieldDescription from "../tools/FieldDescription";
import { LegalEntityType } from "../../static/types/commonTypes/legalEntityType";
import { TheSocietyType } from "../../static/types/commonTypes/theSocietyType";

interface CapitalInputProps<T extends Record<string, unknown>> {
    inputLabel: string,
    fieldDescription: string,
    fieldKey: string,
    capital: number,
    checked: boolean,
    errors: { [key: string]: string },
    onChange: ( data: Partial<T> ) => void,
}

const CapitalInput: React.FC<CapitalInputProps<
    LegalEntityType |
    TheSocietyType
>> = ({
    inputLabel,
    fieldDescription,
    fieldKey,
    capital,
    checked,
    errors,
    onChange,
}) => {

    const [inputValue, setInputValue] = useState<string>(capital.toString().replace(".", ","));

    useEffect(() => {
        setInputValue( capital.toString().replace(".", ",") )
    }, [ capital ])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        // Remplace les points par des virgules
        value = value.replace(".", ",");

        // Vérifie que la saisie correspond à un nombre valide ou une chaîne vide
        if (/^(\d+([,]\d{0,2})?)?$/.test(value)) {
            setInputValue(value);

            // Convertit la chaîne en nombre pour appeler la fonction de mise à jour
            const numericValue = parseFloat(value.replace(",", "."));
            if (!isNaN(numericValue)) {
                onChange({ [ fieldKey ]: numericValue });
            } else {
                onChange({ [ fieldKey ]: 0 }); // Si la saisie est vide, définit le capital à 0
            }
        }
    };

    return (
        <>
            <label htmlFor = "capital" className = "col-sm-2 col-form-label"> { inputLabel } <strong className="text-danger">*</strong> </label>

            <div className = "col-sm-4">

                <span style = {{ position: 'absolute', marginTop: '9px', marginLeft: "10px" }}>
                    { parseFloat(inputValue.replace(",", ".")) > 0 && "€" }
                </span>

                <input
                    className = { `description-input ${ capital !== 0 ? 'ps-4' : '' } form-control ${ ( checked && errors[ fieldKey ] ) ? 'is-invalid' : ''}` }
                    type = "text"
                    id = "capital"
                    value = { inputValue !== '0' ? inputValue : '' }
                    onChange = { handleChange }
                />
                {  ( checked && errors[ fieldKey ] ) && <div className="invalid-feedback"> { errors[ fieldKey ] } </div> }

                <FieldDescription description = { fieldDescription } />

            </div>
        </>
    );
};

export default CapitalInput;
